import type { AccountsWalletsTranslations } from "../interfaces/accountsWallets";

export const accountsWalletsTranslations: AccountsWalletsTranslations = {
  header_title: "Accounts and wallets",
  header_subtitle: "Manage accounts and wallets associated with the platform.",
  header_hint: "Click on an account to view details and the history of who copied the data.",
  search_placeholder: "Search accounts...",
  add_account: "Add account",
  filters_all_currencies: "All currencies",
  accounts_label_singular: "1 account",
  accounts_label_plural: "{{count}} accounts",
  attachments_none: "No attachments",
  attachments_one: "1 attachment",
  attachments_many: "{{count}} attachments",
  card_view_button: "View",
  placeholder_new_account: "New account",
  show_more: "Show more accounts",
  success_create: "Account created successfully.",
  success_update: "Account updated successfully.",
  success_delete: "Account deleted successfully.",
  error_delete: "Could not delete the account.",
  delete_account_modal_title: "Delete account",
  delete_account_modal_message: 'Are you sure you want to delete this account "{{name}}"?',
  delete_account_confirm: "Delete",
  card_delete_aria: "Delete account",
  loading_accounts: "Loading accounts...",
  no_match_search: "No accounts match your search.",
  try_other_terms: "Try different terms or clear the search.",
  no_accounts_registered: "No accounts registered",
  no_accounts_description:
    "You don't have any accounts or wallets yet. When you add one, it will appear here.",
  no_match_currency: "No accounts match the currency filter.",
  adjust_currency_filter: "Adjust the currency filter.",
  searching: "Searching…",
  modal_add_title: "Add account",
  modal_edit_title: "Edit account",
  modal_create_button: "Create account",
  modal_update_button: "Update account",
  modal_cancel: "Cancel",
  form_payment_bank: "Bank account",
  form_payment_crypto: "Crypto wallet",
  form_payment_binance_pay: "Binance Pay",
  form_account_type_savings: "Savings account",
  form_account_type_checking: "Checking account",
  form_label_country: "Country",
  form_select_country: "Select country...",
  form_currency_label: "Currency",
  form_label_payment_method: "Payment method",
  form_select_generic: "Select...",
  form_label_internal_alias: "Internal alias",
  form_internal_alias_placeholder: "E.g.: Main account USD",
  form_label_bank_name: "Bank name",
  form_select_bank: "Select bank...",
  form_label_red: "Network",
  form_select_red: "Select network...",
  form_bank_placeholder: "E.g.: Chase",
  form_label_account_type: "Account type",
  form_select_account_type: "Select account type...",
  form_label_account_number: "Account number",
  form_account_number_placeholder: "E.g.: 1234567890",
  form_extra_methods_title: "Additional payment method details",
  form_select_field_placeholder: "Select {{label}}...",
  form_method_option_ahorros: "Savings",
  form_method_option_corriente: "Checking",
  form_method_option_cpf: "CPF",
  form_method_option_cnpj: "CNPJ",
  form_method_option_email: "Email",
  form_method_option_telefono: "Phone",
  form_method_option_llave_aleatoria: "Random key",
  form_method_option_id_fps: "FPS ID",
  form_method_option_nit: "Nit",
  form_method_option_cc: "Cc",
  form_method_option_ce: "Ce",
  form_method_option_pasaporte: "Passport",
  form_method_option_ppt: "Ppt",
  form_method_placeholder_clabe: "18 digits",
  form_label_network: "Network",
  form_select_network: "Select network...",
  form_label_wallet_address: "Wallet address",
  form_wallet_address_placeholder: "E.g.: 0x71...f92a",
  form_label_notes: "Notes",
  form_notes_placeholder: "Account description or use",
  form_attachments_label: "Attachments",
  form_attachments_upload_edit_label: "Update documents",
  form_attachments_description: "PDF, PNG, JPG, WebP up to 10 MB. You can select multiple files.",
  form_documents_section_title: "Documents",
  detail_title_fallback: "Account details",
  detail_loading: "Loading details...",
  detail_error_load: "Could not load account details.",
  detail_copy_history: "Copy history",
  detail_loading_generic: "Loading...",
  detail_total_copies: "Total copies",
  detail_last_copy: "Last copy",
  detail_never: "Never",
  detail_user: "User",
  detail_times_copied: "Times copied",
  detail_nobody_copied: "No one has copied this account's data yet.",
  detail_error_load_history: "Could not load copy history.",
  detail_edit_button: "Edit",
  detail_copy_bank_info: "Copy bank information",
  detail_copy_info: "Copy information",
  detail_close: "Close",
  detail_copied_toast: "Information copied to clipboard",
  detail_error_copy_toast: "Could not copy information",
  detail_error_download_toast:
    "Could not download the file. The server must return pre-signed URLs for attachments stored in S3.",
  detail_copied: "Copied",
  detail_copy_button_title: "Copy",
  detail_country: "Country",
  detail_notes: "Notes",
  detail_attachments: "Attachments",
  detail_attachments_count: "Attachments ({{count}})",
  detail_file_n: "File {{n}}",
  detail_download: "Download",
  detail_created: "Created",
  detail_updated: "Updated",
  detail_bank_account: "Bank account",
  detail_account_type_label: "Account type",
  detail_crypto_wallet: "Crypto Wallet",
  detail_network_label: "Network",
  detail_wallet_address_label: "Wallet address",
  detail_user_label: "User",
  detail_clipboard_alias_fallback: "Account",

  tracking_title: "Account tracking",
  tracking_subtitle: 'List of accounts and wallets. Click "View" to see who copied the data.',
  tracking_search_placeholder: "Search by alias...",
  tracking_search_aria: "Search accounts",
  tracking_button_refresh: "Refresh",
  tracking_loading: "Loading accounts…",
  tracking_table_showing_one: "Showing 1 record on this page (Total: {{total}})",
  tracking_table_showing_many: "Showing {{count}} records on this page (Total: {{total}})",
  tracking_table_show_label: "Show:",
  tracking_table_empty: "No records to display.",
  tracking_table_th_alias: "Alias",
  tracking_table_th_currency: "Currency",
  tracking_table_th_type: "Type",
  tracking_table_th_created: "Created",
  tracking_table_th_actions: "Actions",
  tracking_table_type_wallet: "Wallet",
  tracking_table_type_bank: "Bank",
  tracking_table_button_view: "View",

  tracking_pagination_records: "Records {{from}} to {{to}} of {{total}}",
  tracking_pagination_total_pages: "Total pages ({{lastPage}})",
  tracking_pagination_first_page: "First page",
  tracking_pagination_prev_page: "Previous page",
  tracking_pagination_next_page: "Next page",
  tracking_pagination_last_page: "Last page",

  structured_bank: "Bank",
  structured_institution: "Institution",
  structured_account_number: "Account number",
  structured_account_type: "Account type",
  structured_document_type: "Document type",
  structured_document_number: "Document number",
  structured_llave_bre_b: "Bre-B key",
  structured_celular_nequi: "Nequi phone number",
  structured_pix_key_type: "Pix key type",
  structured_pix_key: "Pix key",
  structured_clabe: "CLABE (18 digits)",
  structured_rut: "RUT",
  structured_email: "Email",
  structured_cci: "CCI number",
  structured_identity_document: "Identity document",
  structured_celular_yape: "Yape phone number",
  structured_celular_plin: "Plin phone number",
  structured_bank_address: "Bank address",
  structured_routing_number: "Routing number",
  structured_swift_bic: "SWIFT / BIC",
  structured_email_phone_zelle: "Email or phone number",
  structured_iban: "IBAN",
  structured_fps_id_type: "Identifier type",
  structured_fps_id: "FPS identifier",
  structured_chats_code: "CHATS code",
  structured_alipay_id: "Alipay ID",
  structured_wechat_id: "WeChat ID",
  structured_account_iban: "IBAN account number",
  structured_celular: "Phone number",
  structured_cbu_cvu: "CBU or CVU",
  structured_cbu: "CBU",
  structured_cvu: "CVU",
  structured_wallet_address: "Wallet address",
  structured_binance_pay_uid: "UID",
  structured_binance_pay_email: "Email",
  structured_label_fallback: "{{key}}",
};
